import React from 'react';

import { BookmarkOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

import { useScorecard } from '../Scorecard';
import { SkillNameProps } from '../types';

function SkillName(props: SkillNameProps) {
  const {
    className,
    variant = 'body-short-02',
    color = 'text-text-secondary',
    containerClassName,
  } = props;
  const [scorecard] = useScorecard();

  const skillName = scorecard?.skill?.name;

  if (!skillName) {
    return null;
  }

  return (
    <Box className={cn('flex flex-row items-center truncate', containerClassName)}>
      <BookmarkOutline className="h-16 w-16 flex-shrink-0 me-6" fillColorToken="text-secondary" />
      <Typography className={cn('truncate', className)} color={color} variant={variant}>
        {skillName}
      </Typography>
    </Box>
  );
}

export default React.memo(SkillName);
